export type Path =
  | `/account/authentication`
  | `/account/profile`
  | `/login`
  | `/logout`
  | `/organizations/$id/settings/members`
  | `/organizations/$id/settings/projects/$projectId`
  | `/projects`
  | `/projects/to/latest`
  | `/projects/$id`
  | `/saml-required`
  | `/system-admin`;
export namespace Path {
  export type Params = {
    '/organizations/$id/settings/members': { id: string };
    '/organizations/$id/settings/projects/$projectId': { id: string; projectId: string };
    '/projects/$id': { id: string };
  };
}

export type Params<P extends Path> = P extends keyof Path.Params
  ? { path: Path.Params[P]; query?: Record<string, string> }
  : { query?: Record<string, string> };

export const route = <P extends Path>(path: P, ...args: P extends keyof Path.Params ? [params: Params<P>] : [params?: Params<P>]) => {
  let fullPath = `/auth${path}`;

  const params = args[0];

  // パスパラメーターを埋め込む
  if (params && 'path' in params && params.path) {
    fullPath = Object.entries(params.path).reduce((path, [key, value]) => path.replace(`$${key}`, value), fullPath as string);
  }
  // クエリパラメーターの付加
  if (params?.query) {
    const queryString = new URLSearchParams(params.query).toString();
    if (queryString) {
      fullPath += `?${queryString}`;
    }
  }

  return fullPath;
};

export const navigate = <P extends Path>(path: P, ...args: P extends keyof Path.Params ? [params: Params<P>] : [params?: Params<P>]) => {
  const fullPath = route(path, ...args);
  window.location.href = fullPath;
};
